export default {
  WelcomeMessage: 'Welcome to Spore',
  InputDataMessage: 'Enter your data',
  EmailLabel: 'Email',
  PasswordLabel: 'Password',
  ForgotPassword: 'Forgot password?',
  Enter: 'Enter',
  Messages:{
    ErrorLogin: 'User invalid.',
    MissingParams: 'Missing Params',
    Alert: 'Alert',
    Correct: 'Correct',
    State: 'State',
    RequiredFields: 'Required field | Required fields',
    EnterPassword: 'Enter your password to continue'
  },
  Labels:{
    Min: 'Min',
    Max: 'Max',
    Time: 'Time',
    TimeUnity: 'Time Unity',
    DeviceLocation: 'Device location',
    Alerts: 'Alerts',
    DeviceInformation: 'Device Information',
    ReportTime: 'Report Time',
    GroundTemperature: 'Ground temperature',
    EnvTemperature: 'Environment temperature',
    Humidity: 'Humidity',
    HumidityGround: 'Humidity ground',
    Precipitation: 'Precipitation',
    Light: 'Light',
    Save: 'Save',
    Filter: 'Filter',
    DeviceName: 'Device name',
    DevEui: 'DevEui',
    Serie: 'Serie',
    Port: 'Port',
    Activate: 'Activate',
    Profile: 'Profile',
    AppId: 'AppId',
    Description: 'Description',
    App: 'App | Apps',
    Status: 'Status',
    DevAddress: 'Device address',
    AppKey: 'App key',
    NetworkKey: 'Network key',
    License: 'License | Licenses',
    Creator: 'User Creator', 
    Modifier: 'User Modifier',
    CreatedAt: 'Created at',
    UpdatedAt: 'Updated at',
    Confirm: 'Confirm',
    Accept: 'Accept',
    Cancel: 'Cancel',
    Client: 'Client',
    Start: 'Start',
    Expire: 'Expire',
    Add: 'Add',
    Detail: 'Detail',
    PublicKey: 'Public Key',
    PrivateKey: 'Private Key',
    Name: 'Name',
    Device: 'Device | Devices',
    Network: 'Network',
    Organization: 'Organization',
    Companies: 'Companies',
    Company: 'Company',
    ContactName: 'Contact Name',
    Address:'Address',
    PhoneNumber: 'Phone Number',
    DeviceProfiles: 'Device Profiles',
    Licenses:'Licenses',
    Apps:'Applications',    
    Assignments:'Assignments',
    GoTo:'Go to',
    DeviceType: 'Device Type',
    LastSeen: 'Last Seen',
    Type: 'Type',
    General: 'General',
    ClassB:'Class B',
    SupportClassB: 'Support Class B',
    ClassC:'Class C',
    SupportClassC: 'Support Class C',
    Codec:'Codec',
    Region: 'Region',
    Uplink:'Uplink',
    Timeout: 'Timeout',
    EncoderScript: 'Encoder Script',
    DecoderScript: 'Decoder Script',
    Next:'Next',
    Back:'Back',
    MacVersion:'Mac Version',
    Active: 'Active',
    Inactive: 'Inactive',
    Expired: 'Expired',
    Search: 'Search',
    All: 'All',
    From: 'From',
    To:'To',
    SelectOne: 'Select one',
    Param:'Param',
    Test:'Test',
    Result: 'Result',
    Confirm: 'Confirm',
    Assign: 'Assign',
    Validity: 'Validity',
    TimeToExpire: 'Time to Expire',
    Report:'Report',
    Edit:'Edit',
    Download:'Download',
    Delete: 'Delete',
    File: 'File',
    Close: 'Close',
    Finish: 'Finish',
    Created: 'Created',
    Asigned: 'Asigned',
  },
  Apps:'Applications',
  Licenses: 'Licenses',
  Devices: 'Devices',
  Logout: 'Logout',
  DeviceProfiles: 'Device Profiles',
  ChangeHistory: 'Change history',
  Companies: 'Companies',
  DeviceTypes: 'Device Types',
  Dashboard: 'Statistics',
  Path:{
    Apps: 'Apps',
    List: 'List',
    Add: 'Add',
    Detail: 'Detail',
    Edit: 'Edit',
    Licenses: 'Licenses',
    Report: 'Report',
    Devices: 'Devices',
    Companies: 'Companies',
    Profiles: 'Profiles',
    DeviceTypes: 'Device Types'
  }
}
